import script from "./ProductPriceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPriceInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductPriceInfo.vue?vue&type=style&index=0&id=1df5a4d7&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df5a4d7"]])

export default __exports__